<template>
  <div>
    <div class="col-md-2" style="float: left">
      <button
        @click="
          () => {
            CopyToClipboard(getApiRefreshToken, Toaster);
          }
        "
        class="button button-5"
      >
        Copy Refresh Token
      </button>
    </div>
    <div style="line-break: anywhere">
      {{ getApiRefreshToken }}
    </div>
  </div>
</template>

<style scoped>
.dataSubscriptionWripper {
  padding: 10px;
}
.button-5 {
  width: auto;
  margin: 5px;
}
</style>

<script>
import "mosha-vue-toastify/dist/style.css";
import { mapGetters } from "vuex";
import { Toaster, CopyToClipboard } from "../../../../customFunctions/Utils.js";
export default {
  name: "show-refresh-token-container",
  computed: {
    ...mapGetters(["getUserData", "getApiRefreshToken"]),
  },
  setup() {
    return { CopyToClipboard, Toaster };
  },
};
</script>
